import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  validations_form: FormGroup;
  errorMessage: string = '';

  validation_messages = {
    'email': [
      { type: 'required', message: 'Email is required.' },
      { type: 'pattern', message: 'Please enter a valid email.' }
    ],
    'password': [
      { type: 'required', message: 'Password is required.' },
      { type: 'minlength', message: 'Password must be at least 5 characters long.' }
    ]
  };

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private modalCtrl: ModalController,
    private storage: Storage,
    private router: Router
  ) { }

  ngOnInit() {
    this.validations_form = this.formBuilder.group({
      email: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
      ])),
      password: new FormControl('', Validators.compose([
        Validators.minLength(5),
        Validators.required
      ])),
    });
  }


  close(goTo = null) {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'dismissed': true,
      'goTo': goTo
    });
  }

  ionViewWillEnter() {
    console.log("login enter");
    this.storage.get('ion_did_tutorial').then(res => {
      if (res !== true) {
        this.router.navigateByUrl('/welcome', { replaceUrl: true });
      }
    });
  }

  tryLogin(value) {
    this.authService.doLogin(value)
      .then(res => {
        this.authService.setCredentials(value);
        this.authService.setLoggedIn(true);
        // this.router.navigateByUrl("/", { skipLocationChange: true });
        this.close();
      }, err => {
        this.errorMessage = err.message;
        console.error(err)
      })
  }

  goRegisterPage() {
    this.close('register');
  }

  goLostPasswordPage() {
    this.close('lost-password');
  }
}
